import Hero from "@/components/home/Hero";
import Intro from "@/components/home/Intro";
import Pillars from "@/components/home/Pillars";
import HomeDestinations from "@/components/home/HomeDestinations";
import FeatureSikkim from "@/components/home/FeatureSikkim";
import HomeExperiences from "@/components/home/HomeExperiences";
import Approach from "@/components/home/Approach";
import JournalTeaser from "@/components/home/JournalTeaser";
import CtaBand from "@/components/CtaBand";
import EditorialMarquee from "@/components/EditorialMarquee";
import { IMAGES, useTitle } from "@/data/site";

export default function Home() {
  useTitle("Urban Trail | Journeys Worth Remembering");

  return (
    <div data-testid="home-page">
      <Hero />
      <Intro />
      <Pillars />
      <HomeDestinations />
      <EditorialMarquee
        dark
        items={[
          "Journeys Worth Remembering",
          "Sikkim",
          "Arunachal Pradesh",
          "Bali",
          "Dubai",
        ]}
      />
      <FeatureSikkim />
      <HomeExperiences />
      <Approach />
      <JournalTeaser />
      <CtaBand
        image={IMAGES.finalCta}
        title="Your next journey starts here."
        sub="Tell us where you want to go, what you want to experience and how you want to travel."
        primaryText="Plan Your Journey"
        primaryTo="/contact"
        secondaryText="Contact Us"
        secondaryTo="/contact"
      />
    </div>
  );
}
